export class ApplicationUserAssignRequest {
    constructor(
        public id: string,
        public assignedToUserId: string
      ) { }
}
